/**
 * API URL Configuration
 * Centralized management of all API endpoints for the application
 */

const base = {
  sentry: 'api/sentry',
}

export const apiUrls = {
  // Sentry Issues
  getSentryIssues: `${base.sentry}/issues`,

  // Search Issues
  searchSentryIssues: `${base.sentry}/issues/search`,

  // Issue Details
  getIssueDetails: (issueId: string) => `${base.sentry}/issues/${issueId}/details`,

  // Priority Counts
  getPriorityCounts: `${base.sentry}/issues/priority-counts`,

  // Severity Percentage
  getSeverityPercentage: `${base.sentry}/issues/severity-percentage`,

  // Trend Graph
  getTrendGraph: `${base.sentry}/issues/trend-graph`,

  // Export Issues
  getExportIssues: `${base.sentry}/issues/export`,

  // CloudWatch Logs - Direct endpoint without api prefix
  getCloudWatchLogs: '/logs/query',

  // CloudWatch Counts
  getCloudWatchCounts: '/logs/query/counts',
} as const
